module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_4.a3cb5a61.png";